var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14713 11.3749C6.14568 10.3372 6.34964 9.30943 6.74725 8.35088C7.14486 7.39233 7.72826 6.52196 8.46382 5.78993C9.19938 5.05791 10.0725 4.4787 11.033 4.08571C11.9934 3.69272 13.0222 3.49371 14.0599 3.50015C18.39 3.53234 21.8536 7.13155 21.8536 11.4738V12.2499C21.8536 16.1673 22.6732 18.4404 23.395 19.6829C23.4728 19.8156 23.5141 19.9665 23.515 20.1204C23.5158 20.2742 23.476 20.4256 23.3997 20.5591C23.3234 20.6927 23.2131 20.8038 23.0802 20.8812C22.9472 20.9586 22.7962 20.9995 22.6423 20.9999H5.35751C5.20364 20.9995 5.0526 20.9586 4.91962 20.8812C4.78664 20.8038 4.67643 20.6926 4.6001 20.559C4.52377 20.4254 4.48403 20.2741 4.48488 20.1202C4.48573 19.9663 4.52714 19.8154 4.60494 19.6827C5.32717 18.4402 6.14713 16.1671 6.14713 12.2499L6.14713 11.3749Z",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21V21.875C10.5 22.8033 10.8687 23.6935 11.5251 24.3499C12.1815 25.0063 13.0717 25.375 14 25.375C14.9283 25.375 15.8185 25.0063 16.4749 24.3499C17.1313 23.6935 17.5 22.8033 17.5 21.875V21",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.d6e12033d5981c6f3b886a8cec54142d.svg";
export { ForwardRef as ReactComponent };